import { defineRecipe as e } from "@pandacss/dev";
const n = e({
  className: "skeleton",
  base: {
    animation: "skeleton-pulse",
    backgroundClip: "padding-box",
    backgroundColor: "gray.a4",
    borderRadius: "l3",
    color: "transparent",
    cursor: "default",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
export {
  n as skeleton
};
